import React from "react";
import styled from "styled-components";
import { Row, Column } from 'react-foundation';

import logoImg from "../static/images/moi-logo.svg";

interface Props {
	children: React.ReactNode;
}

const LogoWrapper = styled.div`
	margin-top: 2rem;
	margin-bottom: 4rem;

	& img {
		width: 100%;
		max-width: 300px;
	}
`;

const MoiLogo = () => (
	<LogoWrapper>
		<img src={logoImg} alt="Moi" />
	</LogoWrapper>
);

const CenteredRow = styled(Row)``;

const CenteredColumn = styled(Column)`
	text-align: center;
`;

CenteredColumn.defaultProps = {
	small: 10,
	medium: 8,
	large: 6,
	centerOnSmall: true,
};

export const CenteredLayout: React.FC<Props> = (props: Props) => (
	<CenteredRow>
		<CenteredColumn>
			<MoiLogo />
			{React.Children.toArray(props.children)}
		</CenteredColumn>
	</CenteredRow>
);
